"use client";

import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { toggleDownload } from "./actions";

export function AdminToggle({ initialEnabled }: { initialEnabled: boolean }) {
  const [enabled, setEnabled] = useState(initialEnabled);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    setLoading(true);
    try {
      const result = await toggleDownload();
      setEnabled(result.enabled);
      if (result.enabled) {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: enabled ? "success.light" : "error.light",
        border: 1,
        borderColor: enabled ? "success.main" : "error.main",
        borderRadius: 2,
        p: 2,
        mb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Box>
        <Typography fontWeight={600} color="text.primary">
          Admin Controls
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Download is currently <strong>{enabled ? "enabled" : "disabled"}</strong>
        </Typography>
      </Box>
      <Button
        variant="contained"
        color={enabled ? "error" : "success"}
        onClick={handleToggle}
        disabled={loading}
      >
        {loading ? "..." : enabled ? "Disable" : "Enable"}
      </Button>
    </Box>
  );
}
